import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Tooltip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import AssignmentLateOutlinedIcon from '@material-ui/icons/AssignmentLateOutlined';
import DoneAllIcon from "@material-ui/icons/DoneAll";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import HowToRegIcon from "@material-ui/icons/HowToReg";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import MenuIcon from "@material-ui/icons/Menu";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import Menu from "@material-ui/core/Menu";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../services/api";
import { exportarExcel } from "../../../core/utils/excelGeneric";
import { numeroATexto } from "../../../core/utils/formatNumATexto";
import { handleGenericUpdate } from "../../../core/utils/handleGeneric";
import { formatearCUIT } from "../../../core/utils/formatedCuit";
import { ADMINISTRACION, ADMINISTRADOR, DIRECTOR, GENERAL } from "../../../core/utils/roles.constants";
import { generarOrdenServicioPDF } from "../../../components/PDF/OrdenServicioPDFGenerator";
import { useAuth } from "../../../contexts/AuthContext";
import CrearOrdenDeServiciosModal from "./adicionales/createOrdenServicio";
import OrdenServicios from "./adicionales/ordenServicios.jsx";
import BotonGenerico from "../../../components/Button/Button";
import ConfirmDialog from "../../../components/Dialogs/ConfirmDialog";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  leftButtonContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  leftButton: {
    display: "flex",
    alignItems: "center",
    textTransform: "none",
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  rightActionsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  searchField: {
    marginRight: theme.spacing(2),
    width: "200px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginBottom: theme.spacing(1),
    },
  },
  iconButtonsContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  errorIcon: {
    color: "green",
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButtons: {
    justifyContent: "center",
  },
  greenButton: {
    color: "green",
    borderColor: "green",
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
  },
  menuIconButton: {
    color: theme.palette.primary.main,
  },
  menuItemIcon: {
    marginRight: theme.spacing(1),
  },
  greenIcon: {
    color: "green",
  },
  dateRangeFormContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  dateRangeFields: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      minWidth: "150px", // Asegura un ancho mínimo para alineación
    },
  },
  dateRangeButton: {
    marginTop: theme.spacing(2),
    alignSelf: "center", // Centrar el botón
  },
  greenBackg: {
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  dialogContentWide: {
    minWidth: "500px", // Añade un ancho mínimo de 500px
    maxWidth: "1000px", // Ajusta a 700px para más espacio
    padding: theme.spacing(3), // Más espacio interno para mejor legibilidad
  },
  dialogTitleCols: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  // Para evitar el solapamiento del texto
  dialogTitleText: {
    marginRight: theme.spacing(3), // Separa el texto del ícono de cerrar
  },
}));

const Servicios = () => {
  const classes = useStyles();

  // Usuario local
  const { getUser } = useAuth();
  const user = getUser();

  const [dataEvents, setDataEvents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showHiddenRecords, setShowHiddenRecords] = useState(false);
  const [showDateRangeForm, setShowDateRangeForm] = useState(false);

  const [openForm, setOpenForm] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [columnConfigOpen, setColumnConfigOpen] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    estadoOS: true,
    FechaCreacion: true,
    NroOS: true,
    Sector: false,
    Solicitante: false,
    Importe: true,
    FechaEntrega: true,
  });

  const [listaPersonal, setListaPersonal] = useState([]);
  const [listaSectores, setListaSectores] = useState([]);

  // ------------------ Estados de filtros ------------------
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedSector, setSelectedSector] = useState("");

  const [sectorFiltrado, setSectorFiltrado] = useState([]);
  const [selectedEstado, setSelectedEstado] = useState("");

  const [os, setOS] = useState(null);

  const iconStyle = (backgroundColor = "orange", fontSize = "30px", color = "white") => {
    return {
      color,
      backgroundColor: backgroundColor,
      borderRadius: "50%",
      fontSize: fontSize,
      padding: "3px",
      boxSizing: "content-box",
      width: "36px",
      height: "36px",
    }
  }

  const fetchData = async () => {
    try {
      const [ordenesDeServicioResponse, sectoresResponse, personalResponse, correosProveedoresResponse] = await Promise.all([
        api.ordenesServicios.getAll(),
        api.sectores.getAll(),
        api.proveedores.getAll(),
        api.correoProveedores.getAll(),
      ]);

      // Crear los mapas de manera más eficiente con reduce
      const createMap = (arr, keyField, valueField = null) => {
        return arr.reduce((map, item) => {
          map[item[keyField]] = valueField ? item[valueField] : item;
          return map;
        }, {});
      };

      const correosPorProveedor = correosProveedoresResponse.reduce((acc, correo) => {
        const idProveedor = correo.proveedor_id;
        if (!acc[idProveedor]) acc[idProveedor] = [];
        acc[idProveedor].push(correo.email);
        return acc;
      }, {});

      const proveedoresConCorreos = personalResponse
        .map((proveedor) => ({
          ...proveedor,
          email: correosPorProveedor[proveedor.idProveedor] || [],
        }))
        .filter((p) => p.oculto === false);

      setSectorFiltrado(sectoresResponse);

      const sectorMap = createMap(sectoresResponse, 'IdSector', 'Nombre');
      const personaMap = createMap(proveedoresConCorreos, 'idProveedor');

      // console.log("user", user);
      const ordenesDeServicio = Array.isArray(ordenesDeServicioResponse)
        ? ordenesDeServicioResponse
          .map(orden => {
            const ordenConDatos = formatearOrdenDeServicio(orden, {
              ordenesDeServicioMap: {},
              sectorMap,
              personaMap,
            });
            return ordenConDatos;
          })
          .filter((r) => {
            // Transferencia: solo ve OS en "Pendiente Transferencia" de su propio sector
            // if (user.es_admin === 4) {
            //   return r.estadoOS === 5 && r.idSector === user.IdSector;
            // }

            // Director: solo ve OS en "Pendiente aprobación Director" de su propio sector
            // if (user.es_admin === 2) {
            //   return r.estadoOS === 6 && r.idSector === user.IdSector;
            // }

            // Administración: solo ve OS en "Pendiente envío cliente" (todos los sectores)
            // if (user.es_admin === 5) {
            //   return r.estadoOS === 7;
            // }

            const sectores = Array.isArray(user.sectores) && user.sectores.length > 0
              ? user.sectores.map(Number) : [Number(user.IdSector)];
            return user.es_admin === ADMINISTRADOR || user.es_admin === ADMINISTRACION || sectores.includes(Number(r.idSector)); 
            // return r.idSector === user.IdSector;
          })
        : [];

      // console.log("ordenesDeServicio", ordenesDeServicio);
      setListaSectores(sectoresResponse);
      setDataEvents(ordenesDeServicio);
      setFilteredEvents(ordenesDeServicio);
      // setListaPersonal(personalResponse.filter((p) => p.Rol === "cliente" && p.Estado === "activo").reverse());
      setListaPersonal(personalResponse.reverse());
    } catch (error) {
      console.error("Error al cargar ordenes de servicio:", error.message);
    }
  };

  const formatearOrdenDeServicio = (orden, map) => {
    const { ordenesDeServicioMap, sectorMap, personaMap } = map;

    const idSector = orden.idSector;
    const idUsuario = orden.IdUsuario;

    return {
      ...orden,
      Fecha: orden.Fecha,
      Sector: sectorMap[idSector] || null,
      Solicitante: personaMap[idUsuario] || null,
    };
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    let temp = [...dataEvents];
    // Filtrar por oculto
    temp = temp.filter((row) => showHiddenRecords || !row.oculto);

    // Filtrar por sector
    if (selectedSector) {
      temp = temp.filter((row) => row.idSector === selectedSector);
    }
    // Filtrar por rango de fechas
    if (startDate) {
      temp = temp.filter((row) => new Date(row.FechaCreacion) >= new Date(startDate));
    }
    if (endDate) {
      temp = temp.filter((row) => new Date(row.FechaCreacion) <= new Date(endDate));
    }

    if (selectedEstado !== "") {
      temp = temp.filter((row) => row.estadoOS === Number(selectedEstado));
    }

    // Filtro de búsqueda
    if (searchText) {
      const text = searchText.toLowerCase();
      temp = temp.filter((event) =>
        Object.values(event).some(
          (value) =>
            value !== null && value !== undefined && String(value).toLowerCase().includes(text)
        )
      );
    }

    const nuevoTemp = temp.reverse();

    setFilteredEvents(nuevoTemp);
    setPage(0);
  }, [dataEvents, searchText, selectedSector, startDate, endDate, showHiddenRecords, selectedEstado]);


  const handleOpenDetailsModal = (os) => {
    setOS(os);
    setOpenDetailsModal(true);
  };

  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false)
  };

  const handleSuccessOS = (ordenUpdate) => {
    if (!os) return;

    const mergeOrden = (row) => {
      if (row !== os) return row;
      return {
        ...row,
        estadoOS: ordenUpdate.estadoOS,
        observacionRechazo: ordenUpdate.observacionRechazo,
        IdUsuario: ordenUpdate.IdUsuario,
        codigoPresupuesto: ordenUpdate.codigoPresupuesto,
        fechaEntrega: ordenUpdate.fechaEntrega,
        plazoEntrega: ordenUpdate.plazoEntrega,
        idSector: ordenUpdate.idSector,
        moneda: ordenUpdate.moneda,
        tipoMoneda: ordenUpdate.tipoMoneda,
        tipoDeCambio: ordenUpdate.tipoDeCambio,
        importeTotal: ordenUpdate.importeTotal,
        diasHabiles: ordenUpdate.diasHabiles,
      };
    };

    setDataEvents((prev) => prev.map(mergeOrden));
    setFilteredEvents((prev) => prev.map(mergeOrden));
    setOS((prev) => (prev ? mergeOrden(prev) : prev));
  }

  const handleSearchChange = (event) => {
    const text = event.target.value.toLowerCase();
    setSearchText(text);
    const filtered = dataEvents.filter((event) =>
      Object.values(event).some((value) =>
        value != null &&
        value.toString().toLowerCase().includes(text)
      )
    ).reverse();
    setFilteredEvents(filtered);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = (rowIndex) => {
    setSelectedRow(rowIndex);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleHiddenRecords = () => {
    setShowHiddenRecords((prev) => !prev);
    handleMenuClose();
    setPage(0);
  };

  const formatEmails = (emails) => {
    if (Array.isArray(emails) && emails.length) {
      const normalized = emails
        .map((emailItem) => (typeof emailItem === "string" ? emailItem : emailItem?.email))
        .filter((emailItem) => typeof emailItem === "string" && emailItem.trim());
      if (normalized.length) return normalized.join(", ");
    }
    if (typeof emails === "string" && emails.trim()) return emails;   // por si ya viene como string
    return "Sin correos";
  };

  const handleVerPDF = async (row) => {
    // console.log("row", row);
    try {
      const itemsOSResponse = await api.itemsOS.getAll();
      const filteredItemsOS = itemsOSResponse.filter(item => item.idOrdenServicio === row.idOS);

      const subtotal = filteredItemsOS.reduce((acc, item) => {
        const precio = parseFloat(item.precioUnitario);
        const cant = parseFloat(item.cantidad);
        if (isNaN(precio) || isNaN(cant)) return acc;
        return acc + precio * cant;
      }, 0);

      const tipoCambio = row.tipoDeCambio || 1;
      const totalConvertido = subtotal * tipoCambio;

      const [año, mes, día] = row.FechaCreacion.split("-");
      const nuevaFecha = `${día}-${mes}-${año}`;

      if (!row.Solicitante) row.Solicitante = {};

      const data = {
        unidadTecnica: "Instituto de Investigaciones Mineras",
        contactoEmail: "transferenciaiim@unsj.edu.ar",
        contactoTelefono: "+54 264 4220556 interno 23",
        laboratorio: row.Sector || "Sin laboratorio",
        numero: `001-00${row.idOS}`,
        fecha: nuevaFecha,
        // fecha: "00/00/2000",
        // cuit: "30-58676233-4",
        cuit: formatearCUIT(row.Solicitante.cuit),
        ingresosBrutos: "no contribuyente",
        solicitante: row.Solicitante.ApellidoyNombre ?? "No ingresado",
        codigoPostal: row.Solicitante.codigoPostal ?? "No ingresado",
        domicilio: row.Solicitante.Direccion ?? "No ingresado",
        localidad: row.Solicitante.localidad ?? "No ingresado",
        condVenta: row.Solicitante.condicionFrenteAlIva ?? "No ingresado",
        provincia: row.Solicitante.provincia ?? "No ingresado",
        iva: "Exento", // #TODO Preguntar
        telefono: row.Solicitante.Telefono ?? "No ingresado",
        tipoCambio: row.tipoDeCambio,
        personaContacto: row.Solicitante.personaDeContacto ?? "No ingresado",
        emailContacto: formatEmails(row?.Solicitante?.email),
        items: filteredItemsOS,
        importe: totalConvertido,
        importeTotal: row.importeTotal,
        // importeEnTexto: "doscientos cincuenta con 00/100",
        importeEnTexto: numeroATexto(Number(row.importeTotal)),
        plazoEntrega: row.plazoEntrega || "Sin plazo",
        validezOferta: "30 dias",
        moneda: row.moneda,
        codigoPresupuesto: row.codigoPresupuesto || "",
      };

      generarOrdenServicioPDF(data, { openInNewTab: true });
    } catch (error) {
      console.error("ERROR al obtener items relacionados:", error);
    }
  };

  const exportToCSV = async () => {
    const columnas = [
      { key: 'estadoOS', label: 'Estado' },
      { key: 'FechaCreacion', label: 'Fecha de creación' },
      { key: 'idOS', label: 'N° Orden' },
      { key: 'plazoEntrega', label: 'Plazo de entrega' },
      { key: 'Sector', label: 'Sector' },
      { key: 'Solicitante', label: 'Solicitante' },
      { key: 'importeTotal', label: 'Importe' },
      { key: 'fechaEntrega', label: 'Fecha de entrega' },
    ];

    const renderEstadoTexto = (estadoId) => {
      switch (estadoId) {
        case 0: return 'Nuevo';
        case 1: return 'Pendiente';
        case 2: return 'En Proceso';
        case 3: return 'Completado';
        case 4: return 'Cancelado';
        case 'visible': return ''
        default: return 'Sin Estado';
      }
    };

    const formatearDato = (key, valor) => {
      switch (key) {
        case 'estadoOS':
          return valor ? renderEstadoTexto(valor) : 'Sin estado';
        case 'importeTotal':
          return valor != null ? `$ ${valor}` : '$ 0.00';
        case 'FechaCreacion':
        case 'fechaEntrega':
          return valor || 'Sin fecha';
        case 'idOS':
          return valor || 'Sin número';
        case 'Sector':
          return valor || 'Sin sector';
        case 'Solicitante':
          return valor || 'Sin solicitante';
        default:
          return valor ?? '';
      }
    };

    const datosExcel = filteredEvents.map(row => {
      const fila = {};
      columnas.forEach(col => {
        fila[col.label] = formatearDato(col.key, row[col.key]);
      });
      return fila;
    });

    if (datosExcel.length > 0) {
      await exportarExcel('ordenes-servicio', datosExcel);
    }

    handleMenuClose();
  };

  const renderEstadoIcon = (estado) => {
    const tooltip = (text, icon) => {
      return (
        <Tooltip title={<span style={{ fontSize: "0.8rem" }}>{text}</span>} arrow>
          {icon}
        </Tooltip>
      );
    };

    switch (estado) {
      case 1:
        return (
          tooltip("Pendiente ejecución", <AssignmentLateOutlinedIcon style={iconStyle("#f57c00")} />)
        );
      case 5:
        return (
          tooltip("Pendiente aprobación de Transferencia", <HourglassEmptyIcon style={iconStyle("#fb8c00")} />)
        )
      case 6:
        return (
          tooltip("Aceptado por Transferencia", <HowToRegIcon style={iconStyle("#2e7d32")} />)
        );
      case 3:
        return (
          tooltip("Completado", <DoneAllIcon style={iconStyle("#1b5e20")} />)
        )
      case 4:
        return (
          tooltip("Rechazado", <CancelIcon style={iconStyle("red")} />)
        );
      case 7:
        return (
          tooltip("Envío a cliente", <LocalShippingIcon style={iconStyle("#1565c0")} />)
        );
      case 'visible':
        return null;
      // return <HourglassEmptyIcon style={{ color: "white", fontSize: "30px" }} />
      default:
        return null;
    }
  };

  const handleDateRangeClick = () => {
    setShowDateRangeForm(!showDateRangeForm);
  };

  const handleColumnConfigOpen = () => setColumnConfigOpen(true);
  const handleColumnConfigClose = () => setColumnConfigOpen(false);

  const handleColumnVisibilityChange = (column) => {
    setVisibleColumns((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  const handleOpenForm = () => setOpenForm(true);
  const handleCloseForm = () => setOpenForm(false);

  const handleSuccess = () => {
    fetchData(); // 🔁 Recargar al crear/editar
  };

  const visibleRows = filteredEvents.filter(
    (row) => showHiddenRecords ? row.oculto : !row.oculto
  );

  return (
    <div>
      <div className={classes.headerContainer}>
        <div className={classes.leftButtonContainer}>
          {user.es_admin !== DIRECTOR && user.es_admin !== GENERAL && user.es_admin !== ADMINISTRACION && // Solo admin y general pueden crear
            <BotonGenerico
              tipo="nuevo"
              text="Nuevo"
              onClick={handleOpenForm}
            />
          }
          <CrearOrdenDeServiciosModal
            open={openForm}
            onClose={handleCloseForm}
            listaPersonal={listaPersonal}
            listaSector={listaSectores}
            onSuccess={handleSuccess}
            onAddProveedor={(nuevoProveedor) => setListaPersonal((prev) => [nuevoProveedor, ...prev])}
          />
        </div>
        {showHiddenRecords && (
          <Typography variant="body1">
            Las ordenes de servicio solo pueden ser editadas si fueron restauradas
          </Typography>
        )}
        <div className={classes.rightActionsContainer}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Buscar"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div className={classes.iconButtonsContainer}>
            <IconButton color="primary" onClick={handleDateRangeClick}>
              {showDateRangeForm ? <EventBusyIcon /> : <DateRangeIcon />}
            </IconButton>
            <IconButton
              className={classes.menuIconButton}
              onClick={handleMenuOpen}
            >
              <MenuIcon className={classes.greenIcon} />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              keepMounted
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              {/* {user && user.es_admin === 1 && ( */}
              <MenuItem onClick={toggleHiddenRecords}>
                <VisibilityOffIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                {showHiddenRecords ? "Ver registros activos" : "Ver registros ocultos"}
              </MenuItem>
              {/* )} */}
              <MenuItem onClick={exportToCSV}>
                <RestorePageIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon} `}
                />
                Exportar Registros
              </MenuItem>
              <MenuItem onClick={handleColumnConfigOpen}>
                <ViewCompactIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon} `}
                />
                Configurar Columnas
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      {showDateRangeForm && (
        <div className={classes.dateRangeFormContainer}>
          <div className={classes.dateRangeFields}>
            <InputLabel>Desde:</InputLabel>
            <TextField variant="outlined" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
            <InputLabel>Hasta:</InputLabel>
            <TextField variant="outlined" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            <FormControl variant="outlined">
              <InputLabel>Sectores</InputLabel>
              <Select value={selectedSector} onChange={(e) => setSelectedSector(Number(e.target.value))}>
                <MenuItem value="">Todos</MenuItem>
                {sectorFiltrado.map((s) => <MenuItem key={s.IdSector} value={s.IdSector}>{s.Nombre}</MenuItem>)}
              </Select>
            </FormControl>
            <FormControl variant="outlined">
              <InputLabel>Estado</InputLabel>
              <Select
                value={selectedEstado}
                onChange={(e) => setSelectedEstado(e.target.value)}
                label="Estado"
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value={1}>Pendiente ejecución</MenuItem>
                <MenuItem value={5}>Pendiente aprobación de Transferencia</MenuItem>
                <MenuItem value={6}>Aceptado por Transferencia</MenuItem>
                <MenuItem value={7}>Envío a cliente</MenuItem>
                <MenuItem value={3}>Completado</MenuItem>
                <MenuItem value={4}>Rechazado</MenuItem>
              </Select>
            </FormControl>

          </div>
          <BotonGenerico color="primary" onClick={() => { setStartDate(""); setEndDate(""); setSelectedSector(""); setSelectedEstado(""); }} text="Borrar filtros" />
        </div>
      )}

      <Dialog
        open={columnConfigOpen}
        onClose={handleColumnConfigClose}
        classes={{ paper: classes.dialogContentWide }}
        maxWidth="lg"
      >
        <DialogTitle className={classes.dialogTitleCols}>
          Configurar Columnas
          <IconButton
            onClick={handleColumnConfigClose}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {Object.keys(visibleColumns).map((column) => (
            <div key={column} style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={visibleColumns[column]}
                onChange={() => handleColumnVisibilityChange(column)}
              />
              <Typography>{column}</Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {visibleColumns.estadoOS && (
                <TableCell align="center">Estado</TableCell>
              )}
              {visibleColumns.FechaCreacion && (
                <TableCell align="center">Fecha de creación</TableCell>
              )}
              {visibleColumns.NroOS && (
                <TableCell align="center">Nro OS</TableCell>
              )}
              {visibleColumns.Sector && (
                <TableCell align="center">Sector</TableCell>
              )}
              {visibleColumns.Solicitante && (
                <TableCell align="center">Solicitante</TableCell>
              )}
              {visibleColumns.Importe && (
                <TableCell align="center">importe total</TableCell>
              )}
              {visibleColumns.FechaEntrega && (
                <TableCell align="center">F. Entrega</TableCell>
              )}
              <TableCell align="center">Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.length > 0 ? (
              visibleRows
                // .filter((row) => showHiddenRecords || !row.hidden)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={row.idOS || `item - ${index} `}>
                    {visibleColumns.estadoOS && (
                      <TableCell align="center">{renderEstadoIcon(row.estadoOS)}</TableCell>
                    )}
                    {visibleColumns.FechaCreacion && (
                      <TableCell align="center">{row.FechaCreacion ? row.FechaCreacion : "Fecha no disponible"}</TableCell>
                    )}
                    {visibleColumns.NroOS && (
                      <TableCell align="center">{row.idOS ? row.idOS : "No disponible"}</TableCell>
                    )}
                    {visibleColumns.Sector && (
                      <TableCell align="center">{row.Sector ? row.Sector : "Sin Sector"}</TableCell>
                    )}
                    {visibleColumns.Solicitante && (
                      <TableCell align="center">{row.Solicitante ? `${row.Solicitante.ApellidoyNombre}` : "Sin Solicitante"}</TableCell>
                    )}
                    {visibleColumns.Importe && (
                      <TableCell align="center">$ {row.importeTotal || 0}</TableCell>
                    )}
                    {visibleColumns.FechaEntrega && (
                      <TableCell align="center">{row.fechaEntrega ? row.fechaEntrega : "Sin fecha"}</TableCell>
                    )}
                    <TableCell align="center">
                      {!showHiddenRecords && (
                        <IconButton onClick={() => handleOpenDetailsModal(row)}>
                          <SearchIcon color="primary" />
                        </IconButton>
                      )}
                      {/* {!showHiddenRecords && user && user.es_admin !== 2 && user.es_admin !== 4 && user.es_admin !== 5 && ( */}
                      {!showHiddenRecords && (
                        <IconButton onClick={() => handleOpenDialog(row)} className={classes.greenButton}>
                          <DeleteIcon color="secondary" />
                        </IconButton>
                      )}
                      {/* {showHiddenRecords && user && user.es_admin === 1 && ( */}
                      {showHiddenRecords && (
                        <IconButton onClick={() => handleOpenDialog(row)} className={classes.greenButton}>
                          <RestorePageIcon color="secondary" />
                        </IconButton>
                      )}

                      {!showHiddenRecords && (
                        <IconButton onClick={() => handleVerPDF(row)}>
                          <PictureAsPdf style={{ color: '#d32f2f' }} />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length} align="center">
                  No hay Servicios para mostrar
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <OrdenServicios
        open={openDetailsModal}
        onClose={handleCloseDetailsModal}
        onSuccess={handleSuccessOS}
        osDetails={os}
        listaPersonal={listaPersonal}
        listaSector={listaSectores}
        usuarioLocal={user}
      />

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={visibleRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página"
      />

      <ConfirmDialog
        open={open}
        onClose={handleCloseDialog}
        onConfirm={() =>
          handleGenericUpdate({
            selectedItem: selectedRow,
            data: dataEvents,
            setData: (newData) => {
              const nuevaData = newData.reverse();
              setDataEvents(nuevaData);
              setFilteredEvents(nuevaData.filter(row => showHiddenRecords ? row.oculto : !row.oculto));
            },
            apiUpdateFunction: api.ordenesServicios.update,
            idField: "idOS",
            updatePayload: showHiddenRecords ? { oculto: false } : { oculto: true },
            closeDialog: handleCloseDialog,
          })
        }
        title={showHiddenRecords ? "Recuperar Registro" : "Ocultar Registro"}
        description={showHiddenRecords ? "¿Está seguro de que quiere recuperar el registro?" : "¿Está seguro de que quiere ocultar el registro?"}
        confirmText={showHiddenRecords ? "Recuperar registro" : "Ocultar registro"}
        cancelText="Cancelar"
        icon={<ErrorOutlineIcon className={classes.errorIcon} />}
        classes={{
          dialogTitle: classes.dialogTitle,
          dialogContent: classes.dialogContent,
          dialogButtons: classes.dialogButtons,
          confirmButton: classes.greenButton,
          cancelButton: classes.greenButton,
          iconWrapper: classes.iconWrapper,
        }}
      />

      {/* <Dialog open={open} onClose={handleCloseDialog}>
        <DialogTitle className={classes.dialogTitle}>
          <ErrorOutlineIcon className={classes.errorIcon} />
          <Typography variant="h6" gutterBottom>
            Ocultar Registro
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <Typography>
            Los registros ocultados solo serán recuperados por el Administrador.
          </Typography>
        </DialogContent>
        <DialogActions className={classes.dialogButtons}>
          <Button
            variant="outlined"
            onClick={handleHideRecord}
            className={classes.greenButton}
          >
            Ocultar registro
          </Button>
          <Button
            variant="outlined"
            onClick={handleCloseDialog}
            className={classes.greenButton}
          >
            Cancelar
          </Button>
        </DialogActions>
      </Dialog> */}
    </div >
  );
};

export default Servicios;
